import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

export const VoiceAlbumSelect = ({
  options = [],
  placeholder = '選択してください',
  currentValue,
  setCurrentValue
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const containerRef = useRef(null)

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev)
  }

  const handleSelect = (option) => {
    setCurrentValue(option)
    setIsOpen(false)
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  return (
    <div ref={containerRef} className="relative w-full">
      <div
        onClick={toggleDropdown}
        className={clsx(
          isOpen ? 'bg-candy-pink' : 'bg-white',
          'w-fit rounded-[5px] p-1 cursor-pointer border border-candy-pink flex items-center justify-between text-[11px] gap-0.5 mr-auto'
        )}
      >
        <img
          src={isOpen ? currentValue.activeIcon : currentValue.deactiveIcon}
          className="h-[13px] w-[13px]"
        />
        <span className={clsx(isOpen ? 'text-white' : 'text-candy-pink')}>
          {currentValue ? currentValue.label : placeholder}
        </span>
        <span
          className={`transform rotate-180 ${
            isOpen ? 'text-white' : 'text-candy-pink rotate-180'
          } text-sm`}
        >
          ▲
        </span>
      </div>

      {/* Always rendered dropdown with transition */}
      <ul
        className={clsx(
          'flex flex-col absolute w-fit h-fit z-20 mt-1 origin-top transition-all duration-300 ease-in-out gap-[1px]',
          isOpen ? 'opacity-100 scale-100' : 'opacity-0 scale-95 pointer-events-none'
        )}
        style={{ boxShadow: '0px 4px 4px 0px #00000040' }}
      >
        {options.map((option, index) => (
          <li
            key={index}
            className="z-30 bg-white p-1 w-full gap-[6px] group flex hover:bg-candy-pink transition duration-150 ease-in-out whitespace-nowrap overflow-hidden text-ellipsis cursor-pointer text-[11px] hover:text-white"
            onClick={() => handleSelect(option)}
          >
            <img src={option.deactiveIcon} className="h-[13px] w-[13px] group-hover:hidden" />
            <img src={option.activeIcon} className="h-[13px] w-[13px] hidden group-hover:block" />
            <span>{option.label}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}

VoiceAlbumSelect.propTypes = {
  options: PropTypes.array,
  setCurrentValue: PropTypes.func,
  placeholder: PropTypes.string,
  currentValue: PropTypes.object
}
